module.exports = __webpack_public_path__ + "img/ic_fail_connect.d31810d9.svg";